(function () {
  const PUBLIC_KEY =
    (window.UPLOADCARE_PUBLIC_KEY) ||
    (document.querySelector('script[data-uploadcare-public-key]') || {}).dataset?.uploadcarePublicKey ||
    '15a7c593584b1a91024d';

  function uploadcareReady() {
    return typeof window.uploadcare !== 'undefined' && typeof window.uploadcare.fileFrom === 'function';
  }

  function waitForUploadcare(cb) {
    if (uploadcareReady()) return cb();
    const start = Date.now();
    const tick = setInterval(function () {
      if (uploadcareReady()) {
        clearInterval(tick);
        cb();
      } else if (Date.now() - start > 10000) {
        clearInterval(tick);
        cb();
      }
    }, 100);
  }

  function initZone(zone) {
    if (zone.dataset.uploadInitialized === 'true') return;
    zone.dataset.uploadInitialized = 'true';

    const fileInput = zone.querySelector('[data-upload-artwork-file]');
    const hiddenInput = zone.querySelector('[data-upload-artwork-url]');
    const labelEl = zone.querySelector('[data-upload-artwork-label]');
    const filenameEl = zone.querySelector('[data-upload-artwork-filename]');
    const filenameTextEl = zone.querySelector('[data-upload-artwork-filename-text]') || filenameEl;
    const previewEl = zone.querySelector('[data-upload-artwork-preview]');
    const contentEl = zone.querySelector('[data-upload-artwork-content]');
    const clearBtn = zone.querySelector('[data-upload-artwork-clear]');
    if (!fileInput || !hiddenInput || !labelEl || !contentEl) return;
    const baseLabel = labelEl.textContent;

    function setState(state) {
      zone.dataset.state = state;
    }

    function showUploaded(file, cdnUrl) {
      hiddenInput.value = cdnUrl;
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      filenameTextEl.textContent = file.name;
      filenameEl.hidden = false;
      if (previewEl) {
        if (file.type && file.type.indexOf('image/') === 0) {
          previewEl.onerror = function () { previewEl.hidden = true; };
          previewEl.onload = function () { previewEl.hidden = false; };
          previewEl.src = cdnUrl + '-/preview/-/scale_crop/64x64/center/-/format/auto/';
        } else {
          previewEl.removeAttribute('src');
          previewEl.hidden = true;
        }
      }
      clearBtn.hidden = false;
      contentEl.hidden = true;
      setState('uploaded');
    }

    function reset() {
      hiddenInput.value = '';
      hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
      filenameTextEl.textContent = '';
      filenameEl.hidden = true;
      if (previewEl) {
        previewEl.removeAttribute('src');
        previewEl.hidden = true;
      }
      clearBtn.hidden = true;
      contentEl.hidden = false;
      labelEl.textContent = baseLabel;
      fileInput.value = '';
      setState('idle');
    }

    function showError(msg) {
      labelEl.textContent = msg || 'Upload failed — try again';
      setState('error');
      setTimeout(function () {
        if (zone.dataset.state === 'error') {
          labelEl.textContent = baseLabel;
          setState('idle');
        }
      }, 4000);
    }

    function handleFile(file) {
      if (!file) return;
      setState('uploading');
      labelEl.textContent = 'Uploading…';

      waitForUploadcare(function () {
        if (!uploadcareReady()) {
          showError('Upload service unavailable');
          return;
        }
        try {
          const upload = window.uploadcare.fileFrom('object', file, { publicKey: PUBLIC_KEY });
          upload.progress(function (info) {
            const pct = info && info.progress != null ? Math.round(info.progress * 100) : null;
            labelEl.textContent = pct != null ? 'Uploading… ' + pct + '%' : 'Uploading…';
          });
          upload.done(function (info) {
            showUploaded(file, info.cdnUrl);
          });
          upload.fail(function () {
            showError();
          });
        } catch (e) {
          showError();
        }
      });
    }

    fileInput.addEventListener('change', function (e) {
      const file = e.target.files && e.target.files[0];
      if (file) handleFile(file);
    });

    ['dragenter', 'dragover'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        zone.classList.add('is-dragover');
      });
    });
    ['dragleave', 'dragend', 'drop'].forEach(function (evt) {
      zone.addEventListener(evt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        zone.classList.remove('is-dragover');
      });
    });
    zone.addEventListener('drop', function (e) {
      const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) handleFile(file);
    });

    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      reset();
    });
    clearBtn.addEventListener('mousedown', function (e) {
      e.stopPropagation();
    });
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('[data-upload-artwork-zone]')
      .forEach(initZone);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Re-init on Shopify theme editor section reloads
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
